import React from 'react';
import { atom } from '@reatom/framework';

import type { Context } from './context.ts';
import { createSpyContext } from './context.ts';
import type { Observable } from './observable.ts';

/**
 * @param map
 * @param deps
 * @deprecated use useMapped$ instead
 */
export function useMappedObservable<T>(map: (ctx: Context) => T, deps?: Array<unknown>): Observable<T> {
  return React.useMemo(
    () => ({
      __INTERNAL_DO_NOT_USE_ATOM__: atom((ctx) => map(createSpyContext(ctx))),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps ?? [],
  );
}
